import { render, staticRenderFns } from "./SpeechRecommentWord.vue?vue&type=template&id=f5ccec40&"
import script from "./SpeechRecommentWord.vue?vue&type=script&lang=js&"
export * from "./SpeechRecommentWord.vue?vue&type=script&lang=js&"
import style0 from "./SpeechRecommentWord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports